import AssistantDocumentsAPI from 'dashboard/api/assistant/documents';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import { createStore } from '../storeFactory';

const IN_PROGRESS_STATUS = 'in_progress';

export default createStore({
  name: 'AssistantDocument',
  API: AssistantDocumentsAPI,
  getters: {
    getRecords: state => state.records,
  },
  actions: mutations => ({
    setFetchingList({ commit }, isFetching) {
      commit(mutations.SET_UI_FLAG, { fetchingList: isFetching });
    },
    setRecords({ commit }, { records, meta }) {
      commit(mutations.SET, records);
      commit(mutations.SET_META, meta);
    },
    removeBulkRecords({ commit, getters }, ids) {
      const records = getters.getRecords.filter(
        record => !ids.includes(record.id)
      );
      commit(mutations.SET, records);
    },
    markSyncing({ commit, getters }, ids) {
      const idSet = new Set(ids);
      const records = getters.getRecords.map(record =>
        idSet.has(record.id)
          ? { ...record, status: IN_PROGRESS_STATUS }
          : record
      );
      commit(mutations.SET, records);
    },
    async sync({ dispatch }, id) {
      try {
        await AssistantDocumentsAPI.sync(id);
        dispatch('markSyncing', [id]);
        return id;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
    async upload({ commit }, formData) {
      commit(mutations.SET_UI_FLAG, { creatingItem: true });
      try {
        const response = await AssistantDocumentsAPI.upload(formData);
        // Р9.3: бэкенд отвечает массивом payload (несколько файлов за раз).
        const records = response.data.payload || [response.data];
        records.forEach(record => commit(mutations.UPSERT, record));
        return records;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { creatingItem: false });
      }
    },
  }),
});
